import React from 'react';
import { localizedValue } from './nationalizationViewModel';

const ISSUE_ICONS = {
  critical: 'fa-circle-exclamation',
  error: 'fa-circle-exclamation',
  warning: 'fa-triangle-exclamation',
  info: 'fa-circle-info'
};

export default function NationalizationDataQuality({
  dataQuality = {},
  language,
  t,
  onOpenImport,
  onEditProfile,
  onRefresh,
  refreshing
}) {
  const issues = Array.isArray(dataQuality?.issues) ? dataQuality.issues : [];
  const coverage = Number.isFinite(Number(dataQuality?.coverage_pct))
    ? Math.max(0, Math.min(100, Number(dataQuality.coverage_pct)))
    : null;

  return (
    <section className="nationalization-support-card nationalization-data-quality">
      <div className="nationalization-support-card-header">
        <div>
          <h3>{t('dataQuality.title', 'Data quality')}</h3>
          <p>{t('dataQuality.description', 'The result is only as accurate as the company and employee information supplied.')}</p>
        </div>
        {coverage !== null && (
          <strong>{t('dataQuality.coverage', '{{value}}% assessable', { value: Math.round(coverage) })}</strong>
        )}
      </div>

      {coverage !== null && (
        <div className="nationalization-quality-track" aria-label={t('dataQuality.coverageLabel', 'Data coverage')}>
          <div style={{ width: `${coverage}%` }} />
        </div>
      )}

      {issues.length ? (
        <div className="nationalization-quality-issues">
          {issues.map((issue, index) => {
            const severity = String(issue?.severity || 'info').toLowerCase();
            const issueCode = String(issue?.code || '').replace(/^nationalization\.issue\./, '');
            const translated = t(`dataQuality.issues.${issueCode}`, {
              ...(issue?.params || {}),
              count: issue?.count,
              defaultValue: localizedValue(issue, language, 'message') || issue?.code
            });
            return (
              <article key={`${issue?.code || 'issue'}-${issue?.field || ''}-${index}`} className={`severity-${severity}`}>
                <i className={`fa-solid ${ISSUE_ICONS[severity] || ISSUE_ICONS.info}`} aria-hidden="true" />
                <div>
                  <p>{translated}</p>
                </div>
                {Number(issue?.count || 0) > 0 && <strong>{issue.count}</strong>}
              </article>
            );
          })}
        </div>
      ) : (
        <p className="nationalization-quality-complete">
          <i className="fa-solid fa-circle-check" aria-hidden="true" />
          {t('dataQuality.complete', 'No blocking data issues were found.')}
        </p>
      )}

      {(onOpenImport || onEditProfile || onRefresh) && (
        <div className="nationalization-data-actions">
          {onOpenImport && (
            <button type="button" className="nationalization-secondary-button" onClick={onOpenImport}>
              <i className="fa-solid fa-file-import" aria-hidden="true" />
              {t('actions.updateWorkforce', 'Update workforce data')}
            </button>
          )}
          {onEditProfile && (
            <button type="button" className="nationalization-secondary-button" onClick={onEditProfile}>
              <i className="fa-solid fa-gear" aria-hidden="true" />
              {t('actions.editProfile', 'Edit company profile')}
            </button>
          )}
          {onRefresh && (
            <button type="button" className="nationalization-secondary-button" disabled={refreshing} onClick={onRefresh}>
              <i className={`fa-solid fa-rotate ${refreshing ? 'fa-spin' : ''}`} aria-hidden="true" />
              {refreshing ? t('actions.refreshing', 'Refreshing...') : t('actions.refresh', 'Refresh')}
            </button>
          )}
        </div>
      )}
    </section>
  );
}
